var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import PropTypes from 'prop-types';
import filterXss from 'xss';
import { Container, Row } from 'reactstrap';
import { withMedia } from 'react-media-query-hoc';
import { clearCart, getCart, getNewCart, setCart } from '../app/cart-logic';
import Cart from '../components/Cart/Cart';
import CartHeaderButton from '../components/Cart/CartHeaderButton';
import OrderForm from '../components/OrderForm/OrderForm';
import RestaurantBanner from '../components/Restaurant/RestaurantBanner';
import NotFoundRestaurantMenuPage from '../components/NotFoundRestaurantMenuPage';
import Shapes, { deliveryRestaurantShape } from 'Shapes';
import { enablePopover, expandSidebar, hasStaticHeader } from '../app/ui';
import LogService, { createDerivedStateFromErrorLogger } from '../utils/log';
import { getActiveOrdersCustomRules, getDisabledOrdersText } from '../app/logic';
import { AnalyticsService } from '../utils/tracking';
import RestaurantMenuCategories from '../components/RestaurantMenu/RestaurantMenuCategories';
import RestaurantMenuNav from '../components/RestaurantMenu/RestaurantMenuNav';
import RestaurantMenuHero, { hasHeroImages, } from '../components/RestaurantMenu/RestaurantMenuHero';
import RestaurantMenuInConstruction from '../components/RestaurantMenu/RestaurantMenuInConstruction';
import CustomRules from '../components/common/CustomRules';
import OtoError from '../components/common/OtoError';
import OtoSidebar from '../components/common/OtoSidebar';
import { APIService } from '../services/api';
import { DELIVERY_MODES, OTO_PRODUCTS, REASONS_TO_CLOSE } from '../config';
import OrdersWereDisabledModal from '../components/OrdersWereDisabledModal';
import AddToCartError from '../error-types/AddToCartError';
import { getAppSource, isIframe } from '../utils/url-params';
import RestaurantMenuCartFab from '../components/RestaurantMenu/RestaurantMenuCartFab';
import RestaurantMenuModal from '../components/RestaurantMenu/RestaurantMenuModal';
import OtoAlertNew from '../components/common/OtoAlertNew';
import AlertIcon from '../icons/Alert';
import AddressSelect from 'Comps/modes/AddressSelect';
import DeliveryService, { geocodeByAddress, getRestaurantIsDelivering, } from 'Utils/location';
import DeliveryModeToggler from 'Comps/modes/DeliveryModeToggler';
import VerifyUserModal from 'Comps/VerifyUser/VerifyUserModal';
import CustomerService from 'Utils/customer';
import { PAYMENT_PROVIDERS } from 'App/order-fields';
import OrderCreatedModal from 'Comps/RestaurantMenu/OrderCreatedModal';
import RestaurantInDebugModeAlert from 'Comps/Restaurant/RestaurantInDebugModeAlert';
import Restaurant from 'Utils/restaurant';
import BombardinoSwitchRestaurantBanner from './BombardinoSwitchRestaurantBanner';
var DEFAULT_CART = [];
var COMPONENT_NAME = 'RestaurantMenuPage';
var DEFAULT_VERIFY_CUSTOMER_STATE = {
    isOpen: false,
    initialValues: null,
    onError: null,
    onSuccess: null,
};
var RestaurantMenuPage = /** @class */ (function (_super) {
    __extends(RestaurantMenuPage, _super);
    function RestaurantMenuPage(props) {
        var _this = _super.call(this, props) || this;
        _this.checkDisabledInterval = null;
        _this.checkIfProductsNotMissing = function () {
            var restaurant = _this.props.restaurant;
            if (!Restaurant.hasProduct(restaurant, OTO_PRODUCTS.lubje_orders) &&
                !Restaurant.hasProduct(restaurant, OTO_PRODUCTS.lesznoje_orders) &&
                !Restaurant.hasProduct(restaurant, OTO_PRODUCTS.ostrowje_orders) &&
                !Restaurant.hasProduct(restaurant, OTO_PRODUCTS.website) &&
                !Restaurant.hasProduct(restaurant, OTO_PRODUCTS.iframe)) {
                LogService.importantActivity("Restaurant ".concat(restaurant.name, " has no valid products set"));
            }
        };
        _this.checkIsDisabled = function (options) {
            if (options === void 0) { options = {
                openOopsModal: true,
            }; }
            var openOopsModal = options.openOopsModal, callbackIfNotDisabled = options.callbackIfNotDisabled;
            _this.setState({ ordersStatusLoading: true });
            var url = "/restaurants/".concat(_this.props.restaurant.id, "/orders-status");
            return APIService.get(url)
                .then(function (response) { return response.text(); })
                .then(function (ordersStatus) {
                var isDisabled = Object.keys(REASONS_TO_CLOSE).includes(ordersStatus);
                var isNewlyDisabled = !_this.state.disabledOrdersReason && isDisabled;
                _this.setState({
                    ordersStatusLoading: false,
                    disabledOrdersReason: isDisabled
                        ? REASONS_TO_CLOSE[ordersStatus]
                        : null,
                    ordersClosedModalReason: isNewlyDisabled && openOopsModal
                        ? REASONS_TO_CLOSE[ordersStatus]
                        : null,
                });
                if (isDisabled) {
                    _this.checkDisabledInterval &&
                        clearInterval(_this.checkDisabledInterval);
                }
                if (callbackIfNotDisabled &&
                    typeof callbackIfNotDisabled === 'function' &&
                    !isDisabled) {
                    callbackIfNotDisabled();
                }
            })
                .catch(function (e) {
                _this.setState({
                    ordersStatusLoading: false,
                    disabledOrdersReason: null,
                });
                LogService.fetchError({
                    url: url,
                    e: e,
                    actionName: '/orders-status fetch fail, fallback allowing to order.',
                });
            });
        };
        _this.addToCart = function (dish) {
            var restaurant = _this.props.restaurant;
            var _a = _this.state, addressSelected = _a.addressSelected, currentCart = _a.cart;
            if (!addressSelected && isIframe()) {
                alert('Podaj adres dostawy, lub wybierz opcję "Odbiór osobisty", żeby dodać pozycję do koszyka');
                return Promise.resolve(false);
            }
            var cart = getNewCart(currentCart, dish);
            _this.checkIsDisabled();
            var url = "/restaurants/".concat(restaurant.id, "/menu");
            return APIService.get(url)
                .then(function (response) { return response.json(); })
                .then(function (menu) {
                var item = menu.categories
                    .filter(function (c) { return c.name === dish.category; })
                    .map(function (c) { return c.items; })
                    .flat()
                    .find(function (item) { return item.name === dish.name; });
                if (!item) {
                    LogService.error('No product found', item);
                    throw new AddToCartError('Nie ma takiego produktu');
                }
                if (item.isDisabled) {
                    LogService.error('Product became disabled', item);
                    throw new AddToCartError('Produkt jest niedostępny. Odśwież stronę, aby pobrać aktualne menu.');
                }
                if (item) {
                    _this.updateCart(cart);
                    var isFirst = !currentCart.length && !!cart.length;
                    AnalyticsService.trackAddToCart(restaurant, dish, isFirst);
                    if (isFirst) {
                        expandSidebar();
                    }
                    return true;
                }
            })
                .catch(function (e) {
                if (e && e instanceof AddToCartError) {
                    throw e;
                }
                else {
                    LogService.fetchError({ url: url, e: e, actionName: 'Add to cart menu' });
                    throw new Error('Wystąpił błąd podczas sprawdzania dostępności produktu. Spróbuj ponownie, lub skontaktuj się z nami w celu naprawienia usterki - odwdzięczymy się :)');
                }
            });
        };
        _this.updateCart = function (newCart) {
            setCart(_this.props.restaurant, JSON.stringify(newCart));
            _this.checkBasketStatus({ cart: newCart })
                .then(function (basketStatus) { return _this.setState({ basketStatus: basketStatus }); })
                .catch(function (e) { return console.error(e); });
        };
        _this.checkBasketStatus = function (params) {
            if (params === void 0) { params = {}; }
            var _a = params.cart, items = _a === void 0 ? _this.state.cart : _a, _b = params.promoCode, promoCode = _b === void 0 ? _this.state.promoCode : _b, _c = params.deliveryType, deliveryType = _c === void 0 ? _this.state.deliveryType : _c;
            var _d = _this.state, address = _d.address, addressSelected = _d.addressSelected, coordinates = _d.coordinates, deliveryMode = _d.deliveryMode;
            if (deliveryType === 'Dostawa') {
                LogService.importantActivity("deliveryType key is invalid in checkBasketStatus\n        val from params: ".concat((params || {}).deliveryType, "\n        val from params stringified: ").concat(JSON.stringify((params || {}).deliveryType), "\n        val from state: ").concat(_this.state.deliveryType, "\n        UA: ").concat(window.navigator.userAgent));
                deliveryType = 'delivery';
            }
            if (!addressSelected) {
                return Promise.resolve(null);
            }
            if (!items || !items.length) {
                _this.setState({
                    basketStatus: null,
                    basketLoading: false,
                    cart: [],
                });
                return Promise.resolve(null);
            }
            _this.setState({ basketLoading: true });
            // TODO code smell - checking if promoCode is object or string, to be removed
            // @ts-ignore allow this for now
            var promoCodeName = (promoCode === null || promoCode === void 0 ? void 0 : promoCode.promoCode) ? promoCode.promoCode : promoCode;
            var isNotTakeout = deliveryMode !== 'takeout';
            var addressPart = isNotTakeout ? { address: address } : {};
            var deliveryTypePart = isNotTakeout && !!deliveryType ? { delivery_type: deliveryType } : {};
            var coordsPart = coordinates && coordinates.lng && coordinates.lat
                ? {
                    lng: coordinates.lng,
                    lat: coordinates.lat,
                }
                : {};
            var customerData = CustomerService.getSavedCustomerData();
            var promoCodePart = promoCodeName
                ? {
                    promo_code: promoCodeName,
                    promo_code_name: promoCodeName,
                }
                : {};
            var customerPart = customerData.id ? { customer_id: customerData.id } : {};
            var url = "/restaurants/".concat(_this.props.restaurant.id, "/basket-status");
            var payload = __assign(__assign(__assign(__assign(__assign({ items: items, mode: deliveryMode, source: getAppSource() }, addressPart), coordsPart), deliveryTypePart), promoCodePart), customerPart);
            return APIService.post(url, payload)
                .then(function (response) {
                if (response.status === 200 || response.status === 201) {
                    return response.json();
                }
                throw new Error(response.statusText);
            })
                .then(function (basketStatus) {
                _this.setState({
                    basketLoading: false,
                    basketStatus: basketStatus,
                    cart: items,
                });
                return basketStatus;
            })
                .catch(function (e) {
                return LogService.fetchError({ url: url, e: e, actionName: 'basket status' });
            });
        };
        _this.clearCart = function () {
            _this.setState({ cart: DEFAULT_CART });
            clearCart(_this.props.restaurant);
        };
        _this.applyPromoCode = function (promoCode) {
            _this.setState({ promoCode: promoCode });
            return _this.checkBasketStatus({
                cart: _this.state.cart,
                promoCode: promoCode,
            }).then(function (basketStatus) {
                // TODO fixme & remove cast
                var receivedCode = basketStatus.promo_code_name; // TODO use promo code object here
                var hasDeclineReason = !!(basketStatus === null || basketStatus === void 0 ? void 0 : basketStatus.promo_code_reason);
                _this.setState({
                    // TODO fixme & remove cast
                    promoCode: hasDeclineReason ? null : receivedCode,
                });
                return [receivedCode, basketStatus === null || basketStatus === void 0 ? void 0 : basketStatus.promo_code_reason];
            });
        };
        _this.removeFromCart = function (index) {
            var cart = _this.state.cart;
            var newCart = __spreadArray(__spreadArray([], __read(cart.slice(0, index)), false), __read(cart.slice(index + 1)), false);
            _this.updateCart(newCart);
        };
        _this.toggleCartModal = function () {
            if (!_this.state.cartModalOpen) {
                _this.checkIsDisabled({ openOopsModal: false });
            }
            _this.setState({ cartModalOpen: !_this.state.cartModalOpen });
        };
        _this.toggleCartModalViaFab = function () {
            AnalyticsService.trackOpenCartTotal(_this.props.restaurant, 'fab-button');
            _this.toggleCartModal();
        };
        _this.toggleCartModalViaHeader = function () {
            AnalyticsService.trackOpenCartTotal(_this.props.restaurant, 'header-button');
            _this.toggleCartModal();
        };
        _this.openOrderFormModal = function () {
            _this.setState({
                cartModalOpen: false,
                orderFormModalOpen: true,
            });
            AnalyticsService.trackCheckout(_this.props.restaurant, _this.state.cart);
        };
        _this.setActiveCategory = function (category) {
            return _this.setState({ activeCategory: category });
        };
        _this.closeOrderFormModal = function () { return _this.setState({ orderFormModalOpen: false }); };
        _this.showSuccessModal = function () { return _this.setState({ successModalOpen: true }); };
        _this.closeOrdersClosedModal = function () {
            return _this.setState({ ordersClosedModalReason: null });
        };
        _this.handleAddressChange = function (address) { return _this.setState({ address: address }); };
        _this.handleDeliveryModeChange = function (mode) {
            DeliveryService.saveDeliveryPreferences({ mode: mode }, 'restaurant menu page 1');
            var isTakeoutMode = mode === DELIVERY_MODES[1].name;
            _this.setState({
                addressSelected: isTakeoutMode ? true : !!_this.state.coordinates,
                deliveryMode: mode,
            }, _this.checkBasketStatus);
        };
        _this.handleDeliveryTypeChange = function (deliveryType) {
            if (deliveryType === 'Dostawa') {
                LogService.importantActivity('deliveryType key is invalid in handleDeliveryTypeChange');
                deliveryType = 'delivery';
            }
            DeliveryService.saveDeliveryPreferences({ type: deliveryType }, 'restaurant menu page 2');
            _this.setState({ deliveryType: deliveryType });
            _this.checkBasketStatus({ deliveryType: deliveryType });
        };
        _this.ensureAddressIsValid = function (address) {
            _this.setState({ distanceLoading: true });
            return geocodeByAddress(address)
                .then(function (googleMapsPlace) {
                var newDeliveryPrefs = DeliveryService.mapGooglePlaceToDeliveryPrefs(googleMapsPlace, address, _this.state.deliveryMode);
                DeliveryService.saveDeliveryPreferences(newDeliveryPrefs, 'restaurant menu page 3');
                var coordinates = newDeliveryPrefs.coordinates;
                return _this.setState({ address: address, coordinates: coordinates }, function () {
                    return _this.checkIfGeoPositionIsValid(coordinates);
                });
            })
                .catch(function () {
                LogService.error("Restaurant menu page - address invalid: ".concat(address));
                return _this.setState({ distanceLoading: false });
            });
        };
        _this.updateDeliveryPrefs = function (newDeliveryPrefs) {
            return _this.setState({
                address: newDeliveryPrefs.address,
                coordinates: newDeliveryPrefs.coordinates,
            });
        };
        _this.checkIfGeoPositionIsValid = function (position) {
            var _a = _this.props, restaurant = _a.restaurant, restaurantDetails = _a.restaurantDetails;
            var address = _this.state.address;
            return getRestaurantIsDelivering(restaurant, position)
                .then(function (data) {
                var delivering = data.delivering;
                if (!delivering) {
                    var restaurantMaxDeliveryPart = !!restaurantDetails.delivery &&
                        restaurantDetails.delivery.maxKmDistance
                        ? "Restauracja dowozi do maks. odleg\u0142o\u015Bci ".concat(restaurantDetails.delivery.maxKmDistance, "km.")
                        : '';
                    AnalyticsService.trackDeliveryOutOfRange(restaurant);
                    return _this.setState({
                        addressSelected: false,
                        distanceError: "Brak mo\u017Cliwo\u015Bci dostawy - adres ".concat(address, " jest poza zasi\u0119giem. ").concat(restaurantMaxDeliveryPart),
                        distanceLoading: false,
                    });
                }
                else {
                    return _this.setState({
                        addressSelected: true,
                        distanceLoading: false,
                        distanceError: null,
                    }, _this.checkBasketStatus);
                }
            })
                .catch(function (e) {
                LogService.fetchError({
                    e: e,
                    url: "/restaurants/".concat(restaurant.id, "/distance?lng=").concat(position.lng, "&lat=").concat(position.lat),
                    actionName: 'getRestaurantIsDelivering',
                });
                return _this.setState({
                    addressSelected: false,
                    distanceError: "Wyst\u0105pi\u0142 b\u0142\u0105d podczas wyznaczenia odleg\u0142o\u015Bci dla adresu ".concat(address),
                    distanceLoading: false,
                });
            });
        };
        _this.verifyCustomer = function (formValues, onSuccess, onError) {
            return _this.setState({
                vefiryCustomerModal: {
                    isOpen: true,
                    initialValues: formValues,
                    onError: function (closeModal) {
                        if (closeModal === void 0) { closeModal = true; }
                        closeModal &&
                            _this.setState({ vefiryCustomerModal: { isOpen: false } });
                        onError && onError();
                    },
                    onSuccess: function (customer) {
                        _this.setState({
                            vefiryCustomerModal: DEFAULT_VERIFY_CUSTOMER_STATE,
                        });
                        onSuccess && onSuccess(customer);
                    },
                },
            });
        };
        _this.handleOrderCreate = function (order, stripeInstance, setErrors, setSubmitting) {
            AnalyticsService.trackOrderPurchase(order);
            var isApplePay = order.payment_type === 'apple_pay';
            if (!isApplePay) {
                _this.closeOrderFormModal();
                _this.showSuccessModal();
            }
            if (isApplePay) {
                stripeInstance
                    .redirectToCheckout({
                    // Make the id field from the Checkout Session creation API response
                    // available to this file, so you can provide it as parameter here
                    sessionId: order.redirect_value,
                })
                    .then(function (result) {
                    setErrors({
                        hasError: "Wyst\u0105pi\u0142 problem podczas realizacji p\u0142atno\u015Bci: ".concat(result.error.message),
                    });
                    LogService.error("".concat(COMPONENT_NAME, " Stripe payment error"), result === null || result === void 0 ? void 0 : result.error);
                    console.warn('OrderFormHelpers #2 (apple pay / stripe) sets setSubmitting to false');
                    setSubmitting(false);
                });
            }
            else {
                if (isIframe() && PAYMENT_PROVIDERS.PAYNOW.includes(order.payment_type)) {
                    // TODO remove asterisk!
                    window.top.postMessage({ message: 'paynowRedirect', value: order.redirect_value }, '*');
                }
                else {
                    window.location.href = order.redirect_value;
                }
            }
        };
        var storageCart = filterXss(getCart(props.restaurant));
        var deliveryPreferences = DeliveryService.getDeliveryPreferences();
        var addressSelected = !!deliveryPreferences &&
            (!!deliveryPreferences.coordinates ||
                deliveryPreferences.mode === 'takeout');
        var coordinates = deliveryPreferences && deliveryPreferences.coordinates;
        _this.state = {
            activeCategory: null,
            address: (deliveryPreferences && deliveryPreferences.address) || '',
            addressSelected: addressSelected,
            basketStatus: null,
            basketLoading: false,
            cart: storageCart ? JSON.parse(storageCart) : [],
            cartModalOpen: false,
            coordinates: coordinates,
            deliveryMode: (deliveryPreferences && deliveryPreferences.mode) ||
                DELIVERY_MODES[0].name,
            deliveryType: (deliveryPreferences && deliveryPreferences.type) ||
                DELIVERY_MODES[0].name,
            distanceLoading: false,
            distanceError: null,
            disabledOrdersReason: null,
            hasError: false,
            ordersClosedModalReason: null,
            ordersStatusLoading: false,
            orderFormModalOpen: false,
            promoCode: null,
            sidebarStuck: true,
            successModalOpen: false,
            vefiryCustomerModal: DEFAULT_VERIFY_CUSTOMER_STATE,
        };
        return _this;
    }
    RestaurantMenuPage.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.state, address = _a.address, deliveryMode = _a.deliveryMode;
        var isTakeout = deliveryMode === DELIVERY_MODES[1].name;
        this.checkIfProductsNotMissing();
        if (address && !this.props.onPlace && !isTakeout) {
            this.ensureAddressIsValid(address);
        }
        if (!this.props.onPlace) {
            this.checkBasketStatus({ cart: this.state.cart });
            setTimeout(function () {
                _this.checkIsDisabled({
                    openOopsModal: false,
                    callbackIfNotDisabled: function () {
                        _this.checkDisabledInterval = setInterval(_this.checkIsDisabled, 3 * 60 * 1000);
                    },
                });
            }, 1500);
        }
        setTimeout(function () {
            if (_this.props.media.isDesktop) {
                expandSidebar();
            }
            enablePopover();
        }, 0);
    };
    RestaurantMenuPage.prototype.componentWillUnmount = function () {
        this.checkDisabledInterval && clearInterval(this.checkDisabledInterval);
    };
    RestaurantMenuPage.prototype.render = function () {
        var _a = this.props, onPlace = _a.onPlace, restaurant = _a.restaurant, restaurantDetails = _a.restaurantDetails;
        var hasError = this.state.hasError;
        if (hasError) {
            return React.createElement(OtoError, null);
        }
        if (!restaurantDetails) {
            LogService.error('404 - No restaurant details found, showing OtoDowoz partners', null, { instant: true });
            return React.createElement(NotFoundRestaurantMenuPage, null);
        }
        var menu = onPlace ? restaurant.menu_on_place : restaurant.menu;
        if (!menu) {
            LogService.error('404 - No menu found, showing OtoDowoz partners', null, {
                instant: true,
            });
            return React.createElement(NotFoundRestaurantMenuPage, null);
        }
        if (!restaurantDetails.delivery || this.props.isMenuEmpty) {
            return React.createElement(RestaurantMenuInConstruction, null);
        }
        var categories = (menu || {}).categories;
        var _b = this.state, address = _b.address, addressSelected = _b.addressSelected, basketStatus = _b.basketStatus, cart = _b.cart, deliveryMode = _b.deliveryMode, distanceError = _b.distanceError, distanceLoading = _b.distanceLoading;
        var activeCRs = getActiveOrdersCustomRules(restaurant.custom_rules);
        var hasDisablingCRs = !!activeCRs.filter(function (rule) { return rule === null || rule === void 0 ? void 0 : rule.disableOrder; })
            .length;
        var disabledOrdersText = getDisabledOrdersText(restaurant);
        var areOrdersDisabled = !!disabledOrdersText;
        var isDesktop = this.props.media.isDesktop;
        var isInIframe = isIframe();
        return (React.createElement("div", { "data-iframe-height": true, className: isInIframe ? 'mb-5' : '' },
            onPlace ? null : (React.createElement(CartHeaderButton, { cart: cart, handleClick: this.toggleCartModal, isStatic: isInIframe })),
            !onPlace && !isInIframe && !addressSelected && (React.createElement(AddressSelect, { addressValue: address, addIcon: true, error: distanceError, handleAddressSelect: this.ensureAddressIsValid, handleValueChange: this.handleAddressChange, loading: distanceLoading },
                React.createElement(DeliveryModeToggler, { activeMode: deliveryMode, className: "mt-0 mb-3", setMode: this.handleDeliveryModeChange, showLongLabel: true }))),
            React.createElement(RestaurantMenuHero, { restaurant: restaurant }),
            React.createElement(Container, { className: hasHeroImages(restaurant) ? '' : 'mt-2' },
                React.createElement(Row, { className: "align-items-start" },
                    React.createElement("section", { className: "restaurant-list takeout-list ".concat(hasHeroImages(restaurant) ? 'takeout-list--after-hero' : '') },
                        React.createElement(RestaurantBanner, { basketStatus: basketStatus, isInIframe: isInIframe, deliveryMode: deliveryMode, onPlace: onPlace, restaurant: restaurant },
                            React.createElement("div", { className: "mt-2 mb-2 w-100" },
                                React.createElement("div", { className: "mw-400" },
                                    React.createElement(DeliveryModeToggler, { activeMode: deliveryMode, className: "mt-0 ml-0 mb-2 pl-0", setMode: this.handleDeliveryModeChange, showLongLabel: true }),
                                    deliveryMode !== 'takeout' && (React.createElement(AddressSelect, { addressValue: address, error: distanceError, handleAddressSelect: this.ensureAddressIsValid, handleValueChange: this.handleAddressChange, loading: distanceLoading, showLastUsed: false, type: "plain" }))))),
                        React.createElement(RestaurantInDebugModeAlert, { restaurant: restaurant }),
                        isInIframe && (React.createElement("div", { className: "mt-2 mb-2 w-100" },
                            React.createElement(BombardinoSwitchRestaurantBanner, { restaurant: restaurant }))),
                        !onPlace && (React.createElement(React.Fragment, null,
                            restaurantDetails.alertText && (React.createElement(OtoAlertNew, { className: "col-12 mb-3", color: "danger", icon: React.createElement(AlertIcon, null) }, restaurantDetails.alertText)),
                            areOrdersDisabled && (React.createElement(OtoAlertNew, { color: "info", className: "p-2 px-3 mb-2", withBorder: true }, disabledOrdersText)),
                            React.createElement("div", { className: "empty-d-none mt-2" },
                                React.createElement(CustomRules, { className: "py-1 mb-2", rules: activeCRs })))),
                        React.createElement(RestaurantMenuNav, { menu: menu, activeCategory: this.state.activeCategory, isInIframe: isInIframe }),
                        React.createElement(RestaurantMenuCategories, { addToCart: this.addToCart, categories: categories, discountRules: restaurantDetails.discountRules, isDisabled: hasDisablingCRs || areOrdersDisabled, onPlace: onPlace, setActiveCategory: this.setActiveCategory })),
                    isDesktop && !onPlace && (React.createElement(OtoSidebar, { extractOnDesktop: 20, extractOnMobile: 20, title: "Tw\u00F3j Koszyk (".concat(cart.length || 0, ")"), className: "takeout-sidebar ".concat(isInIframe ? 'takeout-sidebar--integrated' : ''), style: hasStaticHeader() ? { top: '10px' } : {} },
                        React.createElement(DeliveryModeToggler, { activeMode: deliveryMode, className: "mt-0 mb-2", setMode: this.handleDeliveryModeChange }),
                        this.renderCart(hasDisablingCRs))),
                    onPlace || isDesktop ? null : (React.createElement(RestaurantMenuCartFab, { cart: this.state.cart, handleClick: this.toggleCartModal })))),
            this.renderOrderFormModal(),
            this.renderCartModal(hasDisablingCRs),
            !this.props.onPlace && (React.createElement(OrdersWereDisabledModal, { isOpen: !!this.state.ordersClosedModalReason, toggle: this.closeOrdersClosedModal, reason: this.state.ordersClosedModalReason, restaurant: this.props.restaurant })),
            this.renderVerifyCustomerModal(),
            this.renderOrderCreatedModal()));
    };
    RestaurantMenuPage.prototype.renderOrderFormModal = function () {
        var _a = this.props, restaurant = _a.restaurant, restaurantDetails = _a.restaurantDetails;
        var _b = this.state, basketStatus = _b.basketStatus, basketLoading = _b.basketLoading, cart = _b.cart, deliveryMode = _b.deliveryMode, orderFormModalOpen = _b.orderFormModalOpen, promoCode = _b.promoCode;
        return (React.createElement(RestaurantMenuModal, { className: "takeout-modal", iframeStyleKey: "checkoutModal", isOpen: orderFormModalOpen, toggle: this.closeOrderFormModal, title: "Szczeg\u00F3\u0142y zam\u00F3wienia" },
            React.createElement(OrderForm, { applyPromoCode: this.applyPromoCode, 
                // TODO double check if basketStatus is always present
                basketStatus: basketStatus, basketLoading: basketLoading, cart: cart, checkBasketStatus: this.checkBasketStatus, deliveryMode: deliveryMode, onOrderCreate: this.handleOrderCreate, restaurantDetails: restaurantDetails, restaurant: restaurant, promoCode: promoCode, updateDeliveryMode: this.handleDeliveryModeChange, updateDeliveryType: this.handleDeliveryTypeChange, updateDeliveryPrefs: this.updateDeliveryPrefs, verifyCustomer: this.verifyCustomer })));
    };
    RestaurantMenuPage.prototype.renderCartModal = function (hasDisablingCRs) {
        if (this.props.onPlace) {
            return null;
        }
        return (React.createElement(RestaurantMenuModal, { iframeStyleKey: "cartModal", isOpen: this.state.cartModalOpen, toggle: this.toggleCartModal, title: "Zawarto\u015B\u0107 koszyka" },
            React.createElement(DeliveryModeToggler, { activeMode: this.state.deliveryMode, className: "mt-0 mx-0 mb-3", setMode: this.handleDeliveryModeChange }),
            this.renderCart(hasDisablingCRs)));
    };
    RestaurantMenuPage.prototype.renderCart = function (hasDisablingCRs) {
        var _a = this.props, restaurant = _a.restaurant, restaurantDetails = _a.restaurantDetails;
        var _b = this.state, basketLoading = _b.basketLoading, basketStatus = _b.basketStatus, cart = _b.cart, deliveryMode = _b.deliveryMode, disabledOrdersReason = _b.disabledOrdersReason;
        return (React.createElement(Cart, { basketStatus: basketStatus, basketLoading: basketLoading, cart: cart, clearCart: this.clearCart, disabledOrdersReason: disabledOrdersReason, hasDisablingCRs: hasDisablingCRs, isTakeoutMode: deliveryMode === DELIVERY_MODES[1].name, removeItem: this.removeFromCart, restaurant: restaurant, restaurantDetails: restaurantDetails, proceedToPayment: this.openOrderFormModal }));
    };
    RestaurantMenuPage.prototype.renderVerifyCustomerModal = function () {
        var modalData = this.state.vefiryCustomerModal;
        if (modalData && modalData.isOpen) {
            return (React.createElement(VerifyUserModal, { initialValues: modalData.initialValues, onError: modalData.onError, onSuccess: modalData.onSuccess }));
        }
        return null;
    };
    RestaurantMenuPage.prototype.renderOrderCreatedModal = function () {
        return this.state.successModalOpen ? React.createElement(OrderCreatedModal, null) : null;
    };
    RestaurantMenuPage.displayName = COMPONENT_NAME;
    RestaurantMenuPage.propTypes = {
        restaurantDetails: Shapes.ordersConfigShape.isRequired,
        restaurant: deliveryRestaurantShape,
        onPlace: PropTypes.bool,
        isMenuEmpty: PropTypes.bool,
    };
    RestaurantMenuPage.defaultProps = {
        onPlace: false,
    };
    RestaurantMenuPage.getDerivedStateFromError = createDerivedStateFromErrorLogger(COMPONENT_NAME);
    return RestaurantMenuPage;
}(React.PureComponent));
export default withMedia(RestaurantMenuPage);
